import { render, staticRenderFns } from "./CollaboratorsInvitation.vue?vue&type=template&id=1429acc2&"
import script from "./CollaboratorsInvitation.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports